import fetch from 'cross-fetch';
import { FacebookLoginToGameAction, FacebookLoginToGameResponse } from './facebook-login-to-game';

export class RemoteFacebookLoginToGameAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: FacebookLoginToGameAction = async (): Promise<FacebookLoginToGameResponse> => {
		const base: string = this.baseUrl || '';

		const response: Response = await fetch(`${base}/api/auth/facebook/login-to-game`, {
			mode: 'cors',
			credentials: 'include',
			method: 'POST',
		});

		const text = await response.text();
		const jsonResponse = text ? JSON.parse(text) : {};
		return { ...jsonResponse, status: response.status };
	};
}
